import apiFetch from "../../../utils/apiFetch";

function appendDefined(params, key, value) {
  if (value === undefined || value === null || value === "") return;
  params.set(key, String(value));
}

function bboxToString(bbox) {
  if (!bbox) return "";
  return [bbox.minLng, bbox.minLat, bbox.maxLng, bbox.maxLat]
    .map((value) => Number(value).toFixed(6))
    .join(",");
}

async function readJson(res) {
  return res.json();
}

export async function fetchInspectionSummary({ year, signal }) {
  const params = new URLSearchParams();
  appendDefined(params, "year", year);
  const res = await apiFetch(`/api/pole-checkups/map/summary?${params}`, {
    cache: "no-store",
    signal,
  });
  return readJson(res);
}

export async function fetchInspectionLines({ year, bbox, zoom, onlyUninspected, signal }) {
  const params = new URLSearchParams();
  appendDefined(params, "year", year);
  appendDefined(params, "bbox", bboxToString(bbox));
  appendDefined(params, "zoom", zoom);
  if (onlyUninspected) params.set("onlyUninspected", "true");
  const res = await apiFetch(`/api/pole-checkups/map/lines?${params}`, {
    cache: "no-store",
    signal,
  });
  return readJson(res);
}

export async function fetchInspectionPoles({ year, bbox, zoom, onlyUninspected, signal }) {
  const params = new URLSearchParams();
  appendDefined(params, "year", year);
  appendDefined(params, "bbox", bboxToString(bbox));
  appendDefined(params, "zoom", zoom);
  if (onlyUninspected) params.set("onlyUninspected", "true");
  const res = await apiFetch(`/api/pole-checkups/map/poles?${params}`, {
    cache: "no-store",
    signal,
  });
  return readJson(res);
}

export async function fetchInspectionLineDetails({ id, year, signal }) {
  const params = new URLSearchParams();
  appendDefined(params, "year", year);
  const res = await apiFetch(`/api/pole-checkups/map/lines/${id}?${params}`, {
    cache: "no-store",
    signal,
  });
  return readJson(res);
}

export async function fetchInspectionPoleDetails({ id, year, signal }) {
  const params = new URLSearchParams();
  appendDefined(params, "year", year);
  const res = await apiFetch(`/api/pole-checkups/map/poles/${id}?${params}`, {
    cache: "no-store",
    signal,
  });
  return readJson(res);
}
